export default __webpack_public_path__ + "static/media/Ducks.126fd569.png";